import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';

import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {BadgeTypeFactoryService} from 'shared/badges/services/badge-type-factory.service';
import {BadgesDetailsRoutingModule} from './badges-details-routing.module';
import {BadgesDetailsComponent} from './badges-details.component';
import {BadgesDetailsHttpRepository} from './repositories/badges-details.repository.http';
import {BadgesDetailsService} from './services/badges-details.service';
import {TypeSerialModule} from './type-components/type-serial/type-serial.module';
import {BadgeModule} from 'shared/badges/components/badge-component/badge.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    BadgesDetailsRoutingModule,
    LanguageDropdownModule,
    TypeSerialModule,
    BadgeModule,
  ],
  declarations: [
    BadgesDetailsComponent,
  ],
  providers: [
    BadgeTypeFactoryService,
    BadgesDetailsService,
    {
      provide: 'IBadgesDetailsRepository',
      useClass: BadgesDetailsHttpRepository,
    },
  ],
})
export class BadgesDetailsModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/badges/badges-details/badges-details.module.ts